import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHANGE_AUCTION_BET = 'AUCTION :: CHANGE_BET';

export type TChangeAuctionBetPayload = {
  bet: number;
  changedByUser: boolean;
};

export type TChangeAuctionBetAction = IReduxAction<typeof CHANGE_AUCTION_BET, TChangeAuctionBetPayload>;

export const changeAuctionBet = actionGenerator<typeof CHANGE_AUCTION_BET, TChangeAuctionBetPayload>(
  CHANGE_AUCTION_BET,
);
